export const css = {
    root: '_2SGbBvNX',
    up: 'sSWQQQZj',
    actions: '_2KNLrYKL',
    action: '_2YzKHwM-',
    down: '_3bhWPO8O',
    left: 'wf10uRal',
    right: '_3P_HmDca',
    open: 'wgiFqqeC',
    actionTransition: '_29Q_HwbI',
    bottomRight: '_2KpoIt7x',
    bottomCenter: '_25MRuUZk',
    bottomLeft: 'x9nxcM_T',
    rightCenter: '_3QlSDgrj',
    leftCenter: '_1wqDuCuj',
    topLeft: 'GGxp9SKa',
    topCenter: '_2h7ek6E8',
    topRight: '_2Q_bvjr2',
    labelContainer: '_2rmAgp9j',
    label: '_1x4cH_tf',
    labelLeft: '_22PwitMA',
    labelRight: 'u-uyYUR8',
    labelTop: 'BRXP0ctG',
    labelBottom: '_1-1RRZwP',
    ' _key': 'certwise-theme/dojo/speed-dial'
};
export default css;
